import { Component } from '@angular/core';
import { appSettings } from '@app/shared/app-settings';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  appSettings = appSettings;

  skipToContent(event: Event, main: HTMLElement) {
    // App uses HashLocationStrategy (useHash: true), so an href="#main" anchor would be
    // interpreted as a route and redirect to not-found. Move focus manually instead.
    event.preventDefault();
    main.focus();
  }
}
